import {message as Message, Popover} from "antd";
import paperClipIcon from "../../pages/icons/paperclip.svg";
import CreateSeriesOfPostsFromMessageModal from "../modals/CreateSeriesOfPostsFromMessageModal";
import CreatePostFromMessageModalWithButton from "../modals/CreatePostFromMessageModalWithButton";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {fetchWrapper} from "../../helpers";


const MessageString = ({message, snActions}) => {
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	const {t} = useTranslation();
	const isPostIncludes = (message?.content?.toLowerCase()?.includes('пост') || message?.content?.toLowerCase()?.includes('post'));

	const createPostFromMessage = (postText) => {
		setIsLoading(true)
		const newPostDescription = `${postText.trim()}`;
		const date = new Date();
		fetchWrapper
				.post(`${process.env.REACT_APP_API_URL}/assistant/summary`, {
					content: newPostDescription,
					socialNetwork: snActions?.socialNetworks,
					date: date.toISOString(),
				})
				.then((res) => {
					if (res){
						Message.loading(t("functions.generating"));
						navigate(`/create-post/${res.contentPlanId}`);
						// window?.location?.reload();
					}else {
						throw new Error('error');
					}
				})
				.catch((err) => {
					console.error(err);
					Message.error(t("functions.wrong"));
				})
				.finally(()=>{
					setIsLoading(false);
				});
	};
	return (
			<div className='flex items-start'>
				<div
						className={
							`relative max-w-[90%] py-2 px-4 rounded-lg my-2.5 shadow-xl border 
									${message?.role === "assistant" ? "bg-white text-primary mr-auto fade-in-from-left" : "bg-primary text-white ml-auto fade-in-from-right"}`
						}
				>
							<pre className='block text-wrap text-pretty max-w-full font-inherit text-inherit'>
								{message?.content || ''}
							</pre>
					<div
							className={`flex flex-wrap-reverse ${message?.role === "assistant" ? 'justify-between' : 'justify-end'} items-center mt-5 mb-2.5`}>
						<small className={`flex items-center gap-1 py-1 opacity-40 ${message?.role !== "assistant" && 'text-right'}`}>
							{message?.quickFile && (
									<Popover
											overlayStyle={{maxWidth: 300}}
											placement='left'
											content={<small className='text-xs'>{message?.quickFile?.name || message?.quickFile || 'file name not found'}</small>}
											title={null}
									>
										<img className='w-4 h-4 cursor-help invert' src={paperClipIcon} alt="Прикрепить файл"/>
									</Popover>
							)}
							{new Date(message?.date).toLocaleString()}
						</small>
						{/*{(message.role === "assistant" && (message?.content.toLowerCase().includes('пост') || message?.content.toLowerCase().includes('post'))) && (*/}
						{/*		<CreatePostFromMessageModalWithButton*/}
						{/*				createAction={function () {createPostFromMessage(message?.content)}}*/}
						{/*				snAction={snActions?.setSocialNetworks}*/}
						{/*				socialNetworks={snActions?.socialNetworks}*/}
						{/*		/>*/}
						{/*)}*/}
					</div>
				</div>
				{message?.role === "assistant" && (
						<div className='sticky top-0 mr-auto ml-2 flex flex-col justify-center items-center gap-2'>
							{(message?.content.length > 300 || isPostIncludes) && (
									<CreateSeriesOfPostsFromMessageModal
											disabledButton={isLoading}
											message={message}
											snAction={snActions?.setSocialNetworks}
											socialNetworks={snActions?.socialNetworks}
									/>
							)}
							{(message?.content.length > 200 && isPostIncludes) && (
									<CreatePostFromMessageModalWithButton
											disabledButton={isLoading}
											createAction={function () {createPostFromMessage(message?.content)}}
											snAction={snActions?.setSocialNetworks}
											socialNetworks={snActions?.socialNetworks}
									/>
							)}
						</div>
				)}
			</div>
	);
};

export default MessageString;